import React from 'react';
import BioVitalDetailList from './BioVitalDetailList';

// Blood Pressure detail list (reached from /user-bio-vitals BP Count drill-down).
const BPDetailsList = () => (
  <BioVitalDetailList config={{
    title: 'Blood Pressure Details',
    routePath: '/bp-details',
    endpoint: '/admin/api/bp-details',
    valueLabel: 'Blood Pressure',
    valueKey: 'blood_pressure',
    dateLabel: 'Datetime',
    dateKey: 'timestamp_utc',
    dateFmt: 'utc',
    totalLabel: 'Total Blood Pressure',
    breadcrumbType: 'Blood Pressure',
    exportName: 'bp-details.csv',
  }} />
);

export default BPDetailsList;
